import cx from 'classnames';

import { loc } from '@/localization';
import { Clients } from '@/site/pages/Register/SideArea/Clients';

import Logo from './assets/logo.svg?react';
import { Features } from './Features';
import { b, e } from './style.css';

export function SideArea({ logoLink, className: classNameProp }: { logoLink: string; className: string }) {
    const className = cx(b.name, classNameProp);

    return (
        <div className={className}>
            <a
                className={e.logo}
                href={logoLink}
            >
                <Logo />
            </a>
            <h2 className={e.title}>{loc.Registration.JoinOurClients}</h2>
            <Clients />
            <Features />
        </div>
    );
}
